import { Glossary, GlossaryEnum } from 'types/glossary';
import { GLOSSARY } from 'utils/constants/end-points';
import Http from './http';

class GlossaryService {
	getGlossary = (glossaryName: GlossaryEnum): Promise<Glossary> => Http.get(`${GLOSSARY}/${glossaryName}`);
}

export default new GlossaryService();
